import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SalesOrdersService } from '@vendasta/sales-orders';
import { Option } from '@vendasta/forms';

export interface UIOptions {
  tags: Option[];
}

export interface TagsList {
  tags: string[];
}

@Injectable()
export class SalesOrderTagsService {
  private businessId: string;
  private orderId: string;

  tagOptions$: Observable<UIOptions>;

  constructor(private salesOrderService: SalesOrdersService) {}

  initialize(businessId: string, orderId: string, partnerId: string, marketId: string): void {
    this.businessId = businessId;
    this.orderId = orderId;

    this.tagOptions$ = this.salesOrderService
      .listTags(partnerId, {
        marketIds: [marketId],
      })
      .pipe(
        switchMap(({ tags }) =>
          of({
            tags: (tags || []).map((tag) => {
              return {
                name: tag,
                value: tag,
              } as Option;
            }),
          }),
        ),
      );
  }

  updateTags(tags: string[]): Observable<TagsList> {
    return this.salesOrderService.updateTags(this.orderId, this.businessId, tags).pipe(
      switchMap((order) => {
        return of({
          tags: order.tags || [],
        });
      }),
    );
  }
}
